// The 190 permission keys audited from the legacy UserPrivilege API (erp-audit/evidence/schema.txt, PRIV),
// in the audited order, with the English and Arabic labels from the audit dictionary (evidence/i18n_en_ar.json).
// Generated once from the approved prototype (delta-prototype-v0.9, assets/erp-perms.js); edit by hand from here on.
export const PERMISSION_KEYS = [
  "accounts", "accountAdd", "accountDelete", "accountUpdate", "alerts", "alertAdd",
  "alertDelete", "alertUpdate", "allowances", "allowanceAdd", "allowanceDelete", "allowanceUpdate",
  "assets", "assetAdd", "assetDelete", "assetUpdate", "assetDepreciations", "assetDepreciationDelete",
  "assetDepreciationDeport", "assetDepreciationCancelDeport", "assetInvoices", "assetInvoiceAdd", "assetInvoiceDelete", "assetInvoiceUpdate",
  "assetKinds", "assetKindAdd", "assetKindDelete", "assetKindUpdate", "costCenters", "costCenterAdd",
  "costCenterDelete", "costCenterUpdate", "chartOfAccountLevel2s", "chartOfAccountLevel2Add", "chartOfAccountLevel2Delete", "chartOfAccountLevel2Update",
  "chartOfAccountLevel3s", "chartOfAccountLevel3Add", "chartOfAccountLevel3Delete", "chartOfAccountLevel3Update", "invoiceBeginningInventories", "invoiceBeginningInventoryAdd",
  "invoiceBeginningInventoryDelete", "invoiceBeginningInventoryUpdate", "invoiceSales", "invoiceSaleAdd", "invoiceSaleDelete", "invoiceSaleUpdate",
  "invoiceSaleRefunds", "invoiceSaleRefundAdd", "invoiceSaleRefundDelete", "invoiceSaleRefundUpdate", "invoicePurchases", "invoicePurchaseAdd",
  "invoicePurchaseDelete", "invoicePurchaseUpdate", "invoicePurchaseRefunds", "invoicePurchaseRefundAdd", "invoicePurchaseRefundDelete", "invoicePurchaseRefundUpdate",
  "invoiceTransfers", "invoiceTransferAdd", "invoiceTransferDelete", "invoiceTransferUpdate", "invoiceInventories", "invoiceInventoryAdd",
  "invoiceInventoryDelete", "invoiceInventoryUpdate", "invoiceCompromises", "invoiceCompromiseAdd", "invoiceCompromiseDelete", "invoiceCompromiseUpdate",
  "invoiceConsumptions", "invoiceConsumptionAdd", "invoiceConsumptionDelete", "invoiceConsumptionUpdate", "invoiceCorrupteds", "invoiceCorruptedAdd",
  "invoiceCorruptedDelete", "invoiceCorruptedUpdate", "items", "itemAdd", "itemDelete", "itemUpdate",
  "itemCategories", "itemCategoryAdd", "itemCategoryDelete", "itemCategoryUpdate", "itemKinds", "itemKindAdd",
  "itemKindDelete", "itemKindUpdate", "itemUnits", "itemUnitAdd", "itemUnitDelete", "itemUnitUpdate",
  "itemUnitBarcodePrint", "journals", "journalAdd", "journalDelete", "journalUpdate", "journalEntries",
  "journalEntryAdd", "journalEntryDelete", "journalEntryUpdate", "monies", "moneyAdd", "moneyDelete",
  "moneyUpdate", "moneyVerify", "partners", "partnerAdd", "partnerDelete", "partnerUpdate",
  "printers", "printerAdd", "printerDelete", "printerUpdate", "staffers", "stafferAdd",
  "stafferDelete", "stafferUpdate", "stores", "storeAdd", "storeDelete", "storeUpdate",
  "storeBarcode", "taxTypes", "taxTypeAdd", "taxTypeDelete", "taxTypeUpdate", "transfers",
  "transferAdd", "transferDelete", "transferUpdate", "units", "unitAdd", "unitDelete",
  "unitUpdate", "users", "userAdd", "userDelete", "userUpdate", "userPrivileges",
  "userHistory", "warehouses", "warehouseAdd", "warehouseDelete", "warehouseUpdate", "home",
  "setting", "clientArea", "r1chartOfAccountsTree", "r1generalLedger", "r1balanceTrial", "r1chartOfAccountLevel3",
  "r1chartOfAccountLevel3Statment", "r2incomeStatement", "r2balanceSheet", "r3sale", "r3saleRefund", "r3purchase",
  "r3purchaseRefund", "r3details", "r3profits", "r4staffer", "r4stafferStatment", "r4loan",
  "r4reward", "r4deduction", "r4salary", "r5accounts", "r5accountStatement", "r5collect",
  "r5payment", "r6journals", "r6journalStatment", "r6expense", "r6transfer", "r6movementSummary",
  "r7sale", "r7purchase", "r7asset", "r7taxReturn", "r8warehouseBalance", "r8warehouseItems",
  "r9assets", "r9purchase", "r9depreciation", "r9details",
] as const;

export type PermissionKey = (typeof PERMISSION_KEYS)[number];

export const PERMISSION_LABELS: Record<PermissionKey, { en: string; ar: string }> = {
  accounts: { en: "Accounts", ar: "الحسابات" },
  accountAdd: { en: "Account Add", ar: "إضافة الحساب" },
  accountDelete: { en: "Account Delete", ar: "حذف الحساب" },
  accountUpdate: { en: "Account Update", ar: "تعديل الحساب" },
  alerts: { en: "Alerts", ar: "التنبيهات" },
  alertAdd: { en: "Alert Add", ar: "إضافة التنبيهات" },
  alertDelete: { en: "Alert Delete", ar: "حذف التنبيهات" },
  alertUpdate: { en: "Alert Update", ar: "تعديل التنبيهات" },
  allowances: { en: "Allowances", ar: "البدلات" },
  allowanceAdd: { en: "Allowance Add", ar: "إضافة البدلات" },
  allowanceDelete: { en: "Allowance Delete", ar: "حذف البدلات" },
  allowanceUpdate: { en: "Allowance Update", ar: "تعديل البدلات" },
  assets: { en: "Assets", ar: "الأصول الثابتة" },
  assetAdd: { en: "Asset Add", ar: "إضافة الأصول" },
  assetDelete: { en: "Asset Delete", ar: "حذف الأصول" },
  assetUpdate: { en: "Asset Update", ar: "تعديل الأصول" },
  assetDepreciations: { en: "Asset Depreciations", ar: "اهلاك الأصول" },
  assetDepreciationDelete: { en: "Asset Depreciation Delete", ar: "حذف اهلاك الأصول" },
  assetDepreciationDeport: { en: "Asset Depreciation Deport", ar: "ترحيل اهلاك الأصول" },
  assetDepreciationCancelDeport: { en: "Asset Depreciation Cancel Deport", ar: "الغاء ترحيل اهلاك اصول" },
  assetInvoices: { en: "Asset Invoices", ar: "فواتير الأصول" },
  assetInvoiceAdd: { en: "Asset Invoice Add", ar: "إضافة فواتير الأصول" },
  assetInvoiceDelete: { en: "Asset Invoice Delete", ar: "حذف فواتير الأصول" },
  assetInvoiceUpdate: { en: "Asset Invoice Update", ar: "تعديل فواتير الأصول" },
  assetKinds: { en: "Asset Kinds", ar: "انواع الاصول" },
  assetKindAdd: { en: "Asset Kind Add", ar: "إضافة انواع الأصول" },
  assetKindDelete: { en: "Asset Kind Delete", ar: "حذف انواع الأصول" },
  assetKindUpdate: { en: "Asset Kind Update", ar: "تعديل انواع الأصول" },
  costCenters: { en: "Cost Centers", ar: "مراكز التكلفة" },
  costCenterAdd: { en: "Cost Center Add", ar: "إضافة مراكز التكلفة" },
  costCenterDelete: { en: "Cost Center Delete", ar: "حذف مراكز التكلفة" },
  costCenterUpdate: { en: "Cost Center Update", ar: "تعديل مراكز التكلفة" },
  chartOfAccountLevel2s: { en: "Chart Of Account Level 2s", ar: "دليل الحسابات المستوى الثانى" },
  chartOfAccountLevel2Add: { en: "Chart Of Account Level 2 Add", ar: "إضافة المستوى الثانى" },
  chartOfAccountLevel2Delete: { en: "Chart Of Account Level 2 Delete", ar: "حذف المستوى الثانى" },
  chartOfAccountLevel2Update: { en: "Chart Of Account Level 2 Update", ar: "تعديل المستوى الثانى" },
  chartOfAccountLevel3s: { en: "Chart Of Account Level 3s", ar: "دليل الحسابات المستوى الثالث" },
  chartOfAccountLevel3Add: { en: "Chart Of Account Level 3 Add", ar: "إضافة المستوى الثالث" },
  chartOfAccountLevel3Delete: { en: "Chart Of Account Level 3 Delete", ar: "حذف دليل المستوى الثالث" },
  chartOfAccountLevel3Update: { en: "Chart Of Account Level 3 Update", ar: "تعديل دليل المستوى الثالث" },
  invoiceBeginningInventories: { en: "Beginning inventory invoices", ar: "فواتير مخزون أول المدة" },
  invoiceBeginningInventoryAdd: { en: "Beginning inventory add", ar: "إضافة مخزون أول المدة" },
  invoiceBeginningInventoryDelete: { en: "Beginning inventory delete", ar: "حذف مخزون أول المدة" },
  invoiceBeginningInventoryUpdate: { en: "Beginning inventory update", ar: "تعديل مخزون أول المدة" },
  invoiceSales: { en: "Invoice Sales", ar: "فواتير المبيعات" },
  invoiceSaleAdd: { en: "Invoice Sale Add", ar: "إضافة فواتير المبيعات" },
  invoiceSaleDelete: { en: "Invoice Sale Delete", ar: "حذف فواتير المبيعات" },
  invoiceSaleUpdate: { en: "Invoice Sale Update", ar: "تعديل فواتير المبيعات" },
  invoiceSaleRefunds: { en: "Invoice Sale Refunds", ar: "فواتير مرتجعات المبيعات" },
  invoiceSaleRefundAdd: { en: "Invoice Sale Refund Add", ar: "إضافة مرتجعات المبيعات" },
  invoiceSaleRefundDelete: { en: "Invoice Sale Refund Delete", ar: "حذف مرتجعات المبيعات" },
  invoiceSaleRefundUpdate: { en: "Invoice Sale Refund Update", ar: "تعديل مرتجعات المبيعات" },
  invoicePurchases: { en: "Invoice Purchases", ar: "فواتير المشتريات" },
  invoicePurchaseAdd: { en: "Invoice Purchase Add", ar: "إضافة فواتير المشتريات" },
  invoicePurchaseDelete: { en: "Invoice Purchase Delete", ar: "حذف فواتير المشتريات" },
  invoicePurchaseUpdate: { en: "Invoice Purchase Update", ar: "تعديل فواتير المشتريات" },
  invoicePurchaseRefunds: { en: "Invoice Purchase Refunds", ar: "فواتير مرتجعات المشتريات" },
  invoicePurchaseRefundAdd: { en: "Invoice Purchase Refund Add", ar: "إضافة مرتجعات المشتريات" },
  invoicePurchaseRefundDelete: { en: "Invoice Purchase Refund Delete", ar: "حذف مرتجعات المشتريات" },
  invoicePurchaseRefundUpdate: { en: "Invoice Purchase Refund Update", ar: "تعديل مرتجعات المشتريات" },
  invoiceTransfers: { en: "Invoice Transfers", ar: "فواتير تحويلات المخازن" },
  invoiceTransferAdd: { en: "Invoice Transfer Add", ar: "إضافة فواتير تحويلات المخازن" },
  invoiceTransferDelete: { en: "Invoice Transfer Delete", ar: "حذف فواتير تحويلات المخازن" },
  invoiceTransferUpdate: { en: "Invoice Transfer Update", ar: "تعديل فواتير تحويلات المخازن" },
  invoiceInventories: { en: "Invoice Inventories", ar: "فواتير الجرد" },
  invoiceInventoryAdd: { en: "Invoice Inventory Add", ar: "إضافة فواتير الجرد" },
  invoiceInventoryDelete: { en: "Invoice Inventory Delete", ar: "حذف فواتير الجرد" },
  invoiceInventoryUpdate: { en: "Invoice Inventory Update", ar: "تعديل فواتير الجرد" },
  invoiceCompromises: { en: "Invoice Compromises", ar: "فواتير التسوية" },
  invoiceCompromiseAdd: { en: "Invoice Compromise Add", ar: "إضافة فواتير التسوية" },
  invoiceCompromiseDelete: { en: "Invoice Compromise Delete", ar: "حذف فواتير التسوية" },
  invoiceCompromiseUpdate: { en: "Invoice Compromise Update", ar: "تعديل فواتير التسوية" },
  invoiceConsumptions: { en: "Invoice Consumptions", ar: "فواتير الاستهلاك" },
  invoiceConsumptionAdd: { en: "Invoice Consumption Add", ar: "إضافة فواتير الاستهلاك" },
  invoiceConsumptionDelete: { en: "Invoice Consumption Delete", ar: "حذف فواتير الاستهلاك" },
  invoiceConsumptionUpdate: { en: "Invoice Consumption Update", ar: "تعديل فواتير الاستهلاك" },
  invoiceCorrupteds: { en: "Invoice Corrupteds", ar: "فواتير الهالك" },
  invoiceCorruptedAdd: { en: "Invoice Corrupted Add", ar: "إضافة فواتير الهالك" },
  invoiceCorruptedDelete: { en: "Invoice Corrupted Delete", ar: "حذف فواتير الهالك" },
  invoiceCorruptedUpdate: { en: "Invoice Corrupted Update", ar: "تعديل فواتير الهالك" },
  items: { en: "Items", ar: "الأصناف" },
  itemAdd: { en: "Item Add", ar: "إضافة الأصناف" },
  itemDelete: { en: "Item Delete", ar: "حذف الأصناف" },
  itemUpdate: { en: "Item Update", ar: "تعديل الأصناف" },
  itemCategories: { en: "Item Categories", ar: "تصنيفات الصنف" },
  itemCategoryAdd: { en: "Item Category Add", ar: "إضافة تصنيفات الصنف" },
  itemCategoryDelete: { en: "Item Category Delete", ar: "حذف تصنيفات الصنف" },
  itemCategoryUpdate: { en: "Item Category Update", ar: "تعديل تصنيفات الصنف" },
  itemKinds: { en: "Item Kinds", ar: "انواع الأصناف" },
  itemKindAdd: { en: "Item Kind Add", ar: "إضافة انواع الأصناف" },
  itemKindDelete: { en: "Item Kind Delete", ar: "حذف انواع الاصناف" },
  itemKindUpdate: { en: "Item Kind Update", ar: "تعديل أنواع الأصناف" },
  itemUnits: { en: "Item Units", ar: "وحدات الأصناف" },
  itemUnitAdd: { en: "Item unit add", ar: "إضافة وحدات الأصناف" },
  itemUnitDelete: { en: "Item unit delete", ar: "حذف وحدات الأصناف" },
  itemUnitUpdate: { en: "Item unit update", ar: "تعديل وحدات الأصناف" },
  itemUnitBarcodePrint: { en: "Barcode print", ar: "طباعة الباركود" },
  journals: { en: "Journals", ar: "الخزينة" },
  journalAdd: { en: "Journal Add", ar: "إضافة الخزينة" },
  journalDelete: { en: "Journal Delete", ar: "حذف الخزينة" },
  journalUpdate: { en: "Journal Update", ar: "تعديل الخزينة" },
  journalEntries: { en: "Journal Entries", ar: "قيود اليومية" },
  journalEntryAdd: { en: "Journal Entry Add", ar: "إضافة قيود اليومية" },
  journalEntryDelete: { en: "Journal Entry Delete", ar: "حذف قيود اليومية" },
  journalEntryUpdate: { en: "Journal Entry Update", ar: "تعديل قيود اليومية" },
  monies: { en: "Monies", ar: "السندات" },
  moneyAdd: { en: "Money Add", ar: "إضافة السندات" },
  moneyDelete: { en: "Money Delete", ar: "حذف السندات" },
  moneyUpdate: { en: "Money Update", ar: "تعديل السندات" },
  moneyVerify: { en: "Verify receipts", ar: "اعتماد السندات" },
  partners: { en: "Partners", ar: "الشركاء" },
  partnerAdd: { en: "Partner Add", ar: "إضافة شريك" },
  partnerDelete: { en: "Partner Delete", ar: "حذف شريك" },
  partnerUpdate: { en: "Partner Update", ar: "تعديل شريك" },
  printers: { en: "Printers", ar: "الطابعات" },
  printerAdd: { en: "Printer Add", ar: "إضافة الطابعات" },
  printerDelete: { en: "Printer Delete", ar: "حذف الطابعات" },
  printerUpdate: { en: "Printer Update", ar: "تعديل الطابعات" },
  staffers: { en: "Employees", ar: "الموظفين" },
  stafferAdd: { en: "Employee Add", ar: "إضافة الموظفين" },
  stafferDelete: { en: "Employee Delete", ar: "حذف الموظفين" },
  stafferUpdate: { en: "Employee Update", ar: "تعديل الموظفين" },
  stores: { en: "Stores", ar: "الفروع" },
  storeAdd: { en: "Store Add", ar: "إضافة الفروع" },
  storeDelete: { en: "Store Delete", ar: "حذف الفروع" },
  storeUpdate: { en: "Store Update", ar: "تعديل الفروع" },
  storeBarcode: { en: "Branch barcode settings", ar: "إعدادات باركود الفرع" },
  taxTypes: { en: "Tax Types", ar: "انواع الضرائب" },
  taxTypeAdd: { en: "Tax Type Add", ar: "إضافة انواع الضرائب" },
  taxTypeDelete: { en: "Tax Type Delete", ar: "حذف انواع الضرائب" },
  taxTypeUpdate: { en: "Tax Type Update", ar: "تعديل انواع الضرائب" },
  transfers: { en: "Transfers", ar: "تحويلات النقدية" },
  transferAdd: { en: "Transfer Add", ar: "إضافة تحويلات النقدية" },
  transferDelete: { en: "Transfer Delete", ar: "حذف تحويلات النقدية" },
  transferUpdate: { en: "Transfer Update", ar: "تعديل تحويلات النقدية" },
  units: { en: "Units", ar: "الوحدات" },
  unitAdd: { en: "Unit Add", ar: "إضافة الوحدة" },
  unitDelete: { en: "Unit Delete", ar: "حذف الوحدة" },
  unitUpdate: { en: "Unit Update", ar: "تعديل الوحدة" },
  users: { en: "Users", ar: "المستخدمين" },
  userAdd: { en: "User Add", ar: "إضافة المستخدمين" },
  userDelete: { en: "User Delete", ar: "حذف المستخدمين" },
  userUpdate: { en: "User Update", ar: "تعديل المستخدمين" },
  userPrivileges: { en: "User Privileges", ar: "صلاحيات المستخدمين" },
  userHistory: { en: "User History", ar: "سجل المستخدم" },
  warehouses: { en: "Warehouses", ar: "المخازن" },
  warehouseAdd: { en: "Warehouse Add", ar: "إضافة المخازن" },
  warehouseDelete: { en: "Warehouse Delete", ar: "حذف المخازن" },
  warehouseUpdate: { en: "Warehouse Update", ar: "تعديل المخازن" },
  home: { en: "Home", ar: "الرئيسية" },
  setting: { en: "Organization settings", ar: "إعدادات المؤسسة" },
  clientArea: { en: "Client Area", ar: "منطقة العميل" },
  r1chartOfAccountsTree: { en: "Chart Of Accounts Tree", ar: "شجرة الحسابات" },
  r1generalLedger: { en: "General Ledger", ar: "دفتر الأستاذ" },
  r1balanceTrial: { en: "Balance Trial", ar: "ميزان المراجعة" },
  r1chartOfAccountLevel3: { en: "Chart Of Account Level 3", ar: "دليل الحسابات" },
  r1chartOfAccountLevel3Statment: { en: "Chart Of Account Level 3 statement", ar: "كشف دليل الحساب" },
  r2incomeStatement: { en: "Income Statement", ar: "قائمة الدخل" },
  r2balanceSheet: { en: "Balance Sheet", ar: "الميزانية العمومية" },
  r3sale: { en: "Sale", ar: "المبيعات" },
  r3saleRefund: { en: "Sale Refund", ar: "مرتجع المبيعات" },
  r3purchase: { en: "Purchase", ar: "المشتريات" },
  r3purchaseRefund: { en: "Purchase Refund", ar: "مرتجع المشتريات" },
  r3details: { en: "Details", ar: "تفاصيل الفاتورة" },
  r3profits: { en: "Invoice profits report", ar: "تقرير أرباح الفواتير" },
  r4staffer: { en: "Employee", ar: "الموظفين" },
  r4stafferStatment: { en: "Employee statement", ar: "كشف حساب الموظف" },
  r4loan: { en: "Loan", ar: "السلف" },
  r4reward: { en: "Reward", ar: "المكافأت" },
  r4deduction: { en: "Deduction", ar: "الخصومات" },
  r4salary: { en: "Salary", ar: "الرواتب" },
  r5accounts: { en: "Accounts", ar: "الحسابات" },
  r5accountStatement: { en: "Account Statement", ar: "كشف الحساب" },
  r5collect: { en: "Collect", ar: "التحصيل" },
  r5payment: { en: "Payment", ar: "الدفع" },
  r6journals: { en: "Journals", ar: "الخزائن" },
  r6journalStatment: { en: "Journal statement", ar: "كشف حساب خزينة" },
  r6expense: { en: "Expense", ar: "المصاريف" },
  r6transfer: { en: "Transfer", ar: "تحويلات النقدية" },
  r6movementSummary: { en: "Movement Summary", ar: "ملخص الحركة" },
  r7sale: { en: "Sale", ar: "ضرائب المبيعات" },
  r7purchase: { en: "Purchase", ar: "ضرائب المشتريات" },
  r7asset: { en: "Asset", ar: "ضرائب الأصول" },
  r7taxReturn: { en: "Tax Return", ar: "الإقرار الضريبى" },
  r8warehouseBalance: { en: "Warehouse Balance", ar: "المخازن" },
  r8warehouseItems: { en: "Warehouse Items", ar: "جرد المخازن" },
  r9assets: { en: "Assets", ar: "الأصول الثابتة" },
  r9purchase: { en: "Purchase", ar: "مشتريات الأصول" },
  r9depreciation: { en: "Depreciation", ar: "اهلاك الأصول" },
  r9details: { en: "Details", ar: "تفاصيل فواتير الاصول" },
};
